module.exports = __webpack_public_path__ + "static/media/pdf.c4b663cd.svg";